/* Shared */
import { Defaults } from 'application/Shared/Constants';

/*  Objects  */
import { User, UserFromContext } from 'objects/User';

/*  React  */
import React from 'react';

export const UserCell = (props) => {
    const { byId, row } = props;

    if (!row) {
        return null;
    }

    const id = props.column?.id ? row.getValue(props.column.id) : null;

    if (!byId) {
        return (
            <User data={row.original}>
                <UserFromContext link includeTitle />
            </User>
        );
    }

    if (id === Defaults.id0) {
        return row.original?.email;
    }

    return (
        <User includeClients id={id}>
            <UserFromContext link />
        </User>
    );
};
